import { render, staticRenderFns } from "./RatingSelector.vue?vue&type=template&id=c7a95d24&scoped=true"
import script from "./RatingSelector.vue?vue&type=script&lang=js"
export * from "./RatingSelector.vue?vue&type=script&lang=js"
import style0 from "./RatingSelector.vue?vue&type=style&index=0&id=c7a95d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a95d24",
  null
  
)

export default component.exports